package com.eladfinish.bible.contest.platform.haptics

import com.eladfinish.bible.contest.constants.Constants
import com.russhwolf.settings.Settings

interface HapticFeedback {
    fun vibrate(milliseconds: Long)
}

class HapticService(
    private val hapticFeedback: HapticFeedback,
    private val settings: Settings,
) {
    fun vibrateIfAllowed(milliseconds: Long) {
        if (settings.getBoolean(key = Constants.PREF_VIBRATION_SWITCH, defaultValue = true)) {
            hapticFeedback.vibrate(milliseconds)
        }
    }
}

enum class HapticStrength {
    LIGHT,
    MEDIUM,
    HEAVY,
}
